var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addBlock"},[_c('a',{staticClass:"add-block-btn",on:{"click":function($event){return _vm.openMenuShow($event)}}},[_c('i',{staticClass:"iconfont iconplus"})])])}
var staticRenderFns = []

export { render, staticRenderFns }